import { logEvent } from "analytics";
import Script from "next/script";
import { useState, type ReactNode } from "react";
import { ButtonV2 } from "@/ui-kit";
import { Calendar } from "ui-kit/icons";

export const CalendlyPopUp = ({
  meetingBookingUrl,
  buttonStyles,
  buttonTitle,
  onClickEvent,
  blurredBackground,
  lightBlue,
  renderButton,
}: {
  meetingBookingUrl: string;
  buttonStyles?: string;
  buttonTitle: string;
  onClickEvent?: string;
  blurredBackground?: boolean;
  /** Render the light-blue contact variant instead of the default white
   * secondary (used outside the hero, e.g. the signup header). */
  lightBlue?: boolean;
  /**
   * Draw a different control in place of the default `ButtonV2`, given the
   * script's readiness and the handler that opens the popup.
   *
   * The redesigned signup chrome needs a `ButtonV3` here, and the part worth
   * sharing is not the button — it is the widget stylesheet, the script tag
   * and knowing when it is ready. Everything V1 renders is untouched when this
   * is omitted.
   */
  renderButton?: (state: {
    loading: boolean;
    onPress: () => void;
  }) => ReactNode;
}) => {
  const openPopup = () => {
    if (onClickEvent) {
      logEvent(onClickEvent);
    }

    if (window.Calendly) {
      window.Calendly.initPopupWidget({ url: meetingBookingUrl });
    }
  };

  const [isScriptLoading, setIsScriptLoading] = useState(true);

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          .calendly-overlay {
            z-index: 2147483011 !important;
          }
          
          .calendly-popup-close {
            filter: invert(1) !important;
            top: 15px !important;
          }

          @media (min-width: 768px) {
            .calendly-popup-close {
              background-color: black !important;
              background-size: 19px !important;
              background-position: center !important;
              border-radius: 50%;
              height: 50px !important;
              width: 50px !important; 
              top: 15px !important;
            }
          }
          
          @media (max-width: 767px) {
            .calendly-overlay {
              background: white !important;
              z-index:9999999999;
            }
          }

          @media (max-width: 649px) {
            .calendly-close-overlay {
              background: white!important;
            }
          }
          `,
        }}
      />
      <link
        href="https://assets.calendly.com/assets/external/widget.css"
        rel="stylesheet"
      />
      <style></style>
      <Script
        type="text/javascript"
        src="https://assets.calendly.com/assets/external/widget.js"
        onReady={() => {
          setIsScriptLoading(false);
        }}
        onLoad={() => {
          setIsScriptLoading(false);
        }}
      />
      {renderButton ? (
        renderButton({ loading: isScriptLoading, onPress: openPopup })
      ) : (
        <ButtonV2
          variant={
            blurredBackground ? "blurred" : lightBlue ? "lightBlue" : "secondary"
          }
          title={buttonTitle}
          icon={<Calendar />}
          loading={isScriptLoading}
          className={buttonStyles}
          onPress={openPopup}
        />
      )}
    </>
  );
};
